const LOCALHOST = "localhost";
const DEV = ".dev";
const DEFAULT_DOMAIN = "";
const DEFAULT_SECURE = true;
const DEFAULT_PATH = "/";
const currentDate = new Date();
const DEFAULT_EXPIRATION = currentDate.setFullYear(
  currentDate.getFullYear() + 1
);
/**
 * Generates cookie options based on provided options or default values.
 *
 * @param {Object} options An object containing optional parameters for cookie options.
 *   - domain: String representing the domain for the cookie.
 *   - expires: Date representing the expiration date for the cookie.
 *   - path: String representing the path for the cookie.
 *   - secure: Boolean representing whether the cookie is secure.
 *   - httpOnly: Boolean representing whether the cookie is HTTP only.
 * @return {Object} An object containing the generated cookie options.
 */
const getCookieOptions = (options = {}) => {
  const local =
    document.location.hostname.includes(LOCALHOST) ||
    document.location.hostname.includes(DEV);

  const {
    domain = local ? DEFAULT_DOMAIN : options.domain,
    expires = DEFAULT_EXPIRATION,
    path = DEFAULT_PATH,
    secure = DEFAULT_SECURE,
    httpOnly
  } = options;

  const cookieOptions = {
    path,
    secure,
    ...(domain && { domain }),
    ...(expires && { expires }),
    ...(httpOnly && { httpOnly })
  };

  return cookieOptions;
};
/**
 * Sets a cookie with the specified name, value, and options.
 *
 * @param {String} name The name of the cookie.
 * @param {String} value The value of the cookie.
 * @param {Object} opts An object containing optional parameters for cookie options.
 *   - domain: String representing the domain for the cookie.
 *   - expires: Date representing the expiration date for the cookie.
 *   - path: String representing the path for the cookie.
 *   - secure: Boolean representing whether the cookie is secure.
 *   - httpOnly: Boolean representing whether the cookie is HTTP only.
 * @return {void}
 */
const setCookie = (name, value, opts) => {
  const options = getCookieOptions(opts);
  let cookieString = `${name}=${value}`;

  if (options.expires instanceof Date) {
    cookieString += `;expires=${options.expires.toUTCString()}`;
  }

  if (options.path) {
    cookieString += `;path=${options.path}`;
  }

  if (options.domain) {
    cookieString += `;domain=${options.domain}`;
  }

  if (options.secure) {
    cookieString += `;secure`;
  }

  if (options.httpOnly) {
    cookieString += `;httpOnly`;
  }

  document.cookie = cookieString;
};

export default setCookie;
